import { z } from 'zod';
import { HoldingStatus } from '@/types/holding/holding-status.type.ts';

export type Holding = {
    id: number,
    sap_code: string,
    name: string,
    status: HoldingStatus,
};

export const HoldingSchema = z.object({
    id: z.number(),
    sap_code: z.string(),
    name: z.string(),
    status: z.nativeEnum(HoldingStatus),
});
